import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import MetaTags from "../../components/SEO/MetaTags";
import { pageConfigs } from "../../utils/seo";

export default function AdvocacyReimbursement() {
  return (
    <>
      <MetaTags
        title={pageConfigs.blogAdvocacyReimbursement.title}
        description={pageConfigs.blogAdvocacyReimbursement.description}
        keywords={pageConfigs.blogAdvocacyReimbursement.keywords}
        canonical={pageConfigs.blogAdvocacyReimbursement.canonical}
      />
      <div className="bg-white">
      {/* Hero section with title */}
      <div className="bg-darkGreen text-white pt-36 pb-8 mb-16 relative overflow-hidden">
        <div className="relative z-10">
          <div className="max-w-3xl mx-auto text-center px-4">
            <h4 className="text-emerald-400 font-medium mb-2">Blog Post</h4>
            <h1 className="text-4xl lg:text-5xl font-bold mb-4 font-productSans">
              Fownd's Vision For Advocacy and Higher Reimbursement
            </h1>
            <p className="text-emerald-100 text-lg">
              Empowering PTs Through Data and Policy
            </p>
            <p className="text-emerald-200 text-sm mt-4">
              By Christina Rama PT, DPT • June 6, 2025
            </p>
          </div>
        </div>
      </div>

      {/* Blog content */}
      <div className="max-w-3xl mx-auto px-4 pb-16">
        {/* Back button at top */}
        <div className="mb-8">
          <Link
            to="/blogs"
            className="inline-flex items-center px-6 py-3 border border-gray-800 rounded-full text-gray-800 hover:bg-darkGreen hover:text-white transition-colors"
          >
            <ArrowLeft className="mr-2 h-4 w-4" /> Back to Blogs
          </Link>
        </div>

        {/* Blog image */}
        <div className="mb-12">
          <img
            src="/blog/blog-2.png"
            alt="Fownd's Vision For Advocacy and Higher Reimbursement"
            className="w-full rounded-lg shadow-lg"
          />
        </div>

        <div className="prose prose-lg">
          <p className="lead">
            The landscape of reimbursement for physical therapy continues to evolve, with 2025 introducing both challenges and opportunities for clinicians. Recent changes, including adjustments to the Medicare Physician Fee Schedule, increased emphasis on value-based care, and ongoing debates about telehealth reimbursement, have placed continued pressure on clinics to justify the cost and effectiveness of their services. Physical therapists face complex documentation requirements, shrinking reimbursement rates, and the need to demonstrate their impact on patient outcomes.
          </p>

          <p>
            FOWND is committed to developing the platform Notation, that will empower physical therapists to navigate reimbursement challenges and effectively advocate for higher rates.
          </p>

          <h2>Key Features in Development:</h2>

          <h3>1. Data-Driven Value Demonstration</h3>
          <ul>
            <li>Track patient outcomes to highlight reduced recovery times, avoided surgeries, and cost savings.</li>
            <li>Generate reports for payers and legislators to demonstrate the long-term benefits of PT.</li>
          </ul>

          <h3>2. Benchmarking and Industry Advocacy</h3>
          <ul>
            <li>Compare clinic outcomes with industry standards to support fair reimbursement.</li>
            <li>Contribute to collective data advocacy efforts, showing the profession's overall impact.</li>
          </ul>

          <h3>3. Legislative and Payer Advocacy</h3>
          <ul>
            <li>Provide data and patient stories to support lobbying for improved policies for things like Medicare reforms/fair reimbursement rates, improved telehealth expansion, preventative care, etc.</li>
            <li>Enable evidence-based negotiations with insurers to justify higher rates.</li>
          </ul>

          <h3>4. Patient Empowerment</h3>
          <ul>
            <li>Create patient-facing reports that demonstrate treatment value, encouraging advocacy for better coverage.</li>
          </ul>

          <h2>Additional Benefits</h2>
          <ul>
            <li>Compliance Support: Streamlined documentation to reduce denials and demonstrate medical necessity.</li>
            <li>Telehealth Advocacy: Tools to support permanent reimbursement for virtual care.</li>
            <li>Emerging Technologies: Position PT clinics as leaders in AI-driven, cost-effective care.</li>
          </ul>

          <div className="my-8">
            <p className="text-xl font-semibold">
              While our platform is still evolving, our vision is to equip clinics with the tools needed to demonstrate their value, streamline operations, and strengthen their voice in the healthcare system.
            </p>
            <p className="text-lg mt-4">
              Help us as we advocate for the future of physical therapy—get involved at fownd.care.
            </p>
          </div>

          {/* Try Notation CTA Banner */}
          <div className="bg-gradient-to-r from-[#619ed3] to-[#5c91a4] rounded-2xl p-8 text-center my-12">
            <p className="text-white text-lg font-semibold mb-6">
              👉 Try Notation for your next evaluation — no strings attached.
            </p>
            <a
              href="https://notation.fownd.care/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-white text-[#619ed3] px-8 py-3 rounded-full font-semibold hover:bg-gray-100 transition-colors shadow-lg"
            >
              Try Notation
            </a>
          </div>
        </div>

        {/* Back button at bottom */}
        <div className="mt-12">
          <Link
            to="/blogs"
            className="inline-flex items-center px-6 py-3 border border-gray-800 rounded-full text-gray-800 hover:bg-darkGreen hover:text-white transition-colors"
          >
            <ArrowLeft className="mr-2 h-4 w-4" /> Back to Blogs
          </Link>
        </div>
      </div>
      </div>
    </>
  );
} 